import { useNavigate, useParams } from 'react-router-dom';
import ProfileGoBackButton from '../../ProfileGoBackButton/ProfileGoBackButton';
import './OrderPage.css';
import { ARTICL_NAME, BONUS_TO_DOLLAR_RATE, IMG_PLACEHOLDER_PRODUCT, PROFILE_MAIN_LINK, PROFILE_ORDERS_MAIN_LINK } from '../../../../assets/utils/constants';
import { useEffect, useState } from 'react';
import mainAppApi from '../../../../assets/api/MainAppApi';
import MiniPreloader from '../../../MiniPreloader/MiniPreloader';
import { parsePrice, parseStatus, parseTitleForParts } from '../../../../assets/utils/utils';
import ImageWithBackground from '../../../ImageWithBackground/ImageWithBackground';

function OrderPage() {
    const { _id } = useParams()
    const navigate = useNavigate()

    const [order, setOrder] = useState(null)
    const [preloaders, setPreloaders] = useState({
        getData: true,
    })

    useEffect(() => {
        if (!_id) return
        setPreloaders(prevValue => ({
            ...prevValue,
            getData: true,
        }))
        mainAppApi.getExactOrder({ _id })
            .then((res) => {
                console.log(res)
                setOrder(res)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    getData: false,
                }))
            })
    }, [_id])
    return (
        <div className='order-page'>
            {preloaders.getData ?
                <div className='order-page__preloader'>
                    <MiniPreloader />
                </div>
                :
                order ?
                    <>
                        <div className='order-page__heading'>
                            <ProfileGoBackButton
                                onClick={() => {
                                    navigate(`/${PROFILE_MAIN_LINK}/${PROFILE_ORDERS_MAIN_LINK}`)
                                }}
                            />
                            <div className='order-page__heading-title-box' >
                                <p className='order-page__heading-title'>№{order.ai_id}</p>
                                <p className={`order-page__status order-page__status_type_${order.status}`}>{parseStatus(order.status)}</p>
                            </div>
                        </div>
                        {order.order_items && order.order_items.length > 0 ?
                            <div className='order-page__items'>
                                {order.order_items.map((item, i) => {
                                    const item_obj = item.item
                                    const price = item.price
                                    return (
                                        <div className='order-page__item' key={`order-page__item${order._id}_${item.item_id}`}>
                                            < ImageWithBackground
                                                className={`order-page__item-image`}
                                                src={item_obj.files && item_obj.files.length > 0 ? item_obj.files[0]?.urls.orig : IMG_PLACEHOLDER_PRODUCT}
                                                image_format={'10x16'}
                                                key={`${item_obj.files && item_obj.files.length > 0 ? item_obj.files[0]?.urls.orig : IMG_PLACEHOLDER_PRODUCT}${item_obj._id}`}
                                                metadata={item_obj.files && item_obj.files.length > 0 ? item_obj.files[0]?.metadata : null}
                                            />
                                            <div className='order-page__item-info'>
                                                <h3 className="order-page__item-title">{parseTitleForParts(item_obj.name).title}</h3>
                                                {parseTitleForParts(item_obj.name).subtitle ? <p className="order-page__item-subtitle">{parseTitleForParts(item_obj.name).subtitle}</p> : null}
                                                <p className="order-page__item-article">{item_obj?.parameters?.find((item2) => item2.name === ARTICL_NAME) ? item_obj?.parameters?.find((item2) => item2.name === ARTICL_NAME).value : ''}</p>
                                                <div className='order-page__item-separator-line' />
                                                <h3 className='order-page__item-price'>{item.amount} x {parsePrice(price, 'USD')}</h3>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            :
                            null}
                        <div className='order-page__info'>
                            <p className='order-page__info-title'>Your order</p>
                            <div className='order-page__info-separator-line' />
                            <div className='order-page__info-items'>
                                <div className='order-page__info-item'>
                                    <p className='order-page__info-item-title'>Products</p>
                                    <p className='order-page__info-item-value'>{order.different_items}</p>
                                </div>
                                <div className='order-page__info-item'>
                                    <p className='order-page__info-item-title'>For the amount</p>
                                    <p className='order-page__info-item-value'>{parsePrice(order.items_price, 'USD')}</p>
                                </div>
                                {order.discount ?
                                    <div className='order-page__info-item'>
                                        <p className='order-page__info-item-title'>Discount</p>
                                        <p className='order-page__info-item-value'>{parsePrice(order.discount, 'USD')}</p>
                                    </div>
                                    : null
                                }
                                {order.discount_by_value && order.discount_by_value.value && Number(order.discount_by_value.value) > 0 ?
                                    <div className='order-page__info-item'>
                                        <p className='order-page__info-item-title'>Coins used</p>
                                        <p className='order-page__info-item-value'>{Number(order.discount_by_value.value).toLocaleString('us') * BONUS_TO_DOLLAR_RATE} SC</p>
                                    </div>
                                    : null
                                }
                            </div>
                            <div className='order-page__info-separator-line' />
                            <div className='order-page__info-item order-page__info-item_total'>
                                <p className='order-page__info-item-title'>Total:</p>
                                <p className='order-page__info-item-value'>{parsePrice(order.total_price, 'USD')}</p>
                            </div>
                        </div>
                    </>
                    :
                    null
            }

        </div>
    );
}

export default OrderPage